<div class="backBackground">
<div class="transitionEffectAll600 roundedCorner" [ngClass]="{
    mainZero: auth.currentUserIDSig()?.uid == null,
    mainMax:
      sb.currentSidebarSize() === 'max' &&
      auth.currentUserIDSig()?.uid != null,
    mainMin:
      sb.currentSidebarSize() === 'min' &&
      auth.currentUserIDSig()?.uid != null
  }" *transloco="let t">
  <div class="page-content container-fluid base-font-color">  
    <div class="row">
      <div class="col p-0 p-md-1">
        @if (auth.currentUserIDSig()?.uid != null) { @if(showSpinner ||
        !this.auth.currentLangSig()?.lang) {
        <div class="row">
          <div class="col">
            <span class="placeholder-glow">
              <span class="placeholder placeholder-lg col-4"></span>
            </span>
          </div>
          <div class="col text-end">
            <span class="placeholder-glow">
              <span class="placeholder placeholder-lg bg-secondary col-4"></span>
            </span>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col text-center">
            <div class="svl-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        } @if(!showSpinner && this.auth.currentLangSig()?.lang) {
        <div class="page-header base-font-color d-flex justify-content-between mb-2">
          <h2>{{ t('dashboard.header-title') }}</h2>
          <div class="dropdown">
            <button class="btn btn-secondary rounded-pill dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ t('calendar.' + this.period) }}
            </button>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" (click)="this.setPeriod(period)"
                  *ngFor="let period of periodsShortArray; index as i">{{ t('calendar.' + period) }}</a>
              </li>
            </ul>
          </div>
        </div>


        <div class="row g-3">
          <div class="col-6 col-lg-3">
            <div class="card shadow-sm">
              <div class="card-header bg-white shadow-sm d-flex justify-content-between px-2"
                title="{{t('dashboard.KPI-title-balance')}}">
                <span class="KPI-header">{{
                  t('dashboard.balance') | slice : 0 : 15
                  }}</span>
                <span class="material-symbols-outlined KPI-info-icon" data-bs-toggle="modal"
                  data-bs-target="#infoKPIModal">
                  info
                </span>
              </div>
              <div class="card-body text-truncate p-2">
                <div class="my-2">
                  <span class="KPI-main-number" [ngClass]="{
                      'text-bad': this.totalExpense > this.totalBudget
                      }">
                    {{
                    this.totalBudget - this.totalExpense
                    | currency
                    : this.db.currentUserDataSig()?.currency
                    : "symbol-narrow"
                    }}
                  </span>
                </div>
                <div class="d-flex justify-content-start" [ngClass]="{
                      'text-bad': this.totalExpense > this.totalBudget,
                      'text-ok':  this.totalExpense / this.totalBudget > 0.95,
                      'text-good': this.totalBudget > this.totalExpense
                      }" title="{{t('dashboard.KPI-title-balance-footer')}}">
                  <span class="material-symbols-outlined KPI-footer-icon my-auto me-1">
                    @if(this.totalBudget === 0) { circle } @else if(this.totalBudget === this.totalExpense) {
                    trending_flat }
                    @else {clock_loader_10}
                  </span>
                  <span class="KPI-footer d-sm-block fst-italic my-auto">
                    <span class="fw-bold">{{
                      1 -
                      (this.totalBudget - this.totalExpense) /
                      this.totalBudget | percent : "1.1-2"
                      }}</span>
                    <span>
                      {{
                      t('dashboard.KPI-comment-balance-usage-2')
                      | slice : 0 : 15
                      }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="card shadow-sm">
              <div class="card-header bg-white shadow-sm d-flex justify-content-between px-2"
                title="{{t('dashboard.KPI-title-budget')}}">
                <span class="KPI-header">{{
                  t('dashboard.list-col-budget-caps') | slice : 0 : 15
                  }}</span>
                <span class="material-symbols-outlined KPI-info-icon" data-bs-toggle="modal"
                  data-bs-target="#infoKPIModal">
                  info
                </span>
              </div>
              <div class="card-body text-truncate p-2">
                <div class="my-2">
                  <span class="KPI-main-number">{{
                    this.totalBudget
                    | currency
                    : this.db.currentUserDataSig()?.currency
                    : "symbol-narrow"
                    }}</span>
                </div>
                <div class="d-flex justify-content-start" [ngClass]="{
                      'text-neutral': this.prevPeriod < this.minPeriod,
                      'text-bad': this.totalBudget > this.totalBudgetPrev,
                      'text-ok':  this.totalBudget / this.totalBudgetPrev > 0.95,
                      'text-good': this.totalBudget < this.totalBudgetPrev
                      }" title="{{t('dashboard.KPI-title-budget-footer')}}">
                  <span class="material-symbols-outlined KPI-footer-icon my-auto me-1">
                    @if(this.prevPeriod < this.minPeriod) {info}
                    @else if(this.totalBudget === 0) {circle} 
                    @else if(this.totalBudget === this.totalBudgetPrev) {trending_flat} 
                    @else if(this.totalBudget < this.totalBudgetPrev) {trending_down} 
                    @else if (this.totalBudget> this.totalBudgetPrev) {trending_up}
                    @else {}
                  </span>
                  <span class="KPI-footer d-sm-block fst-italic my-auto">
                    <span>
                    </span>
                    @if(this.prevPeriod < this.minPeriod) {
                      {{t('dashboard.KPI-min-period', {  period: t('calendar.' + this.period) })}}
                    }
                    @else if(this.totalBudget === 0) {} @else if(this.totalBudget ===
                    this.totalBudgetPrev) {} @else {
                    <span class="fw-bold">
                      {{
                      calculateAbs(this.totalBudget, this.totalBudgetPrev)
                      | currency
                      : this.db.currentUserDataSig()?.currency
                      : "symbol-narrow"
                      }}</span>
                    <span> (m/m)</span>
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="card shadow-sm">
              <div class="card-header bg-white shadow-sm d-flex justify-content-between px-2"
                title="{{t('dashboard.KPI-title-expense-sum')}}">
                <span class="KPI-header">{{
                  t('dashboard.stats-sum') | slice : 0 : 15
                  }}</span>
                <span class="material-symbols-outlined KPI-info-icon" data-bs-toggle="modal"
                  data-bs-target="#infoKPIModal">
                  info
                </span>
              </div>
              <div class="card-body text-truncate p-2">
                <div class="my-2">
                  <span class="KPI-main-number">{{
                    this.totalExpense
                    | currency
                    : this.db.currentUserDataSig()?.currency
                    : "symbol-narrow"
                    }}</span>
                </div>
                <div class="d-flex justify-content-start" [ngClass]="{
                      'text-neutral': this.prevPeriod < this.minPeriod,
                      'text-bad': this.totalExpense > this.totalExpensePrev,
                      'text-ok':  this.totalExpense / this.totalExpensePrev > 0.95,
                      'text-good': this.totalExpense < this.totalExpensePrev
                      }" title="{{t('dashboard.KPI-title-expense-sum-footer')}}">
                  <span class="material-symbols-outlined KPI-footer-icon my-auto me-1">
                    @if(this.prevPeriod < this.minPeriod) {info}
                    @else if(this.totalExpense === 0) {circle} 
                    @else if(this.totalExpense === this.totalExpensePrev) {trending_flat} 
                    @else if(this.totalExpense < this.totalExpensePrev) {trending_down} 
                    @else if (this.totalExpense> this.totalExpensePrev) {trending_up}
                    @else {}
                  </span>
                  <span class="KPI-footer d-sm-block fst-italic my-auto">
                    @if(this.prevPeriod < this.minPeriod) {
                      {{t('dashboard.KPI-min-period', {  period: t('calendar.' + this.period) })}}
                    } 
                    @else if(this.totalExpense === 0) {} 
                    @else if(this.totalBudget=== this.totalBudgetPrev) {} 
                    @else {
                      <span class="fw-bold">
                        {{
                        calculateAbs(this.totalExpense, this.totalExpensePrev)
                        | currency
                        : this.db.currentUserDataSig()?.currency
                        : "symbol-narrow"
                        }}
                      </span>
                      <span>(m/m)</span>
                      }
                    </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="card shadow-sm">
              <div class="card-header bg-white shadow-sm d-flex justify-content-between px-2"
                title="{{t('dashboard.KPI-title-expense-count')}}">
                <span class="KPI-header">{{
                  t('dashboard.stats-count') | slice : 0 : 15
                  }}</span>
                <span class="material-symbols-outlined KPI-info-icon" data-bs-toggle="modal"
                  data-bs-target="#infoKPIModal">
                  info
                </span>
              </div>
              <div class="card-body text-truncate p-2">
                <div class="my-2">
                  <span class="KPI-main-number">{{ this.countExpense }}</span>
                </div>
                <div class="d-flex justify-content-start" [ngClass]="{
                      'text-neutral': this.prevPeriod < this.minPeriod,
                      'text-bad': this.countExpense > this.countExpensePrev,
                      'text-ok':  this.countExpense / this.countExpensePrev > 0.95,
                      'text-good': this.countExpense < this.countExpensePrev
                      }" title="{{t('dashboard.KPI-title-expense-count-footer')}}">
                  <span class="material-symbols-outlined KPI-footer-icon my-auto me-1">
                    @if(this.prevPeriod < this.minPeriod) {info}
                    @else if(this.countExpense === 0) { circle } 
                    @else if(this.countExpense === this.countExpensePrev) {trending_flat } 
                    @else if(this.countExpense < this.countExpensePrev) { trending_down } 
                    @else if(this.countExpense> this.countExpensePrev) { trending_up }
                     @else {}
                  </span>
                  <span class="KPI-footer d-sm-block fst-italic my-auto">
                    @if(this.prevPeriod < this.minPeriod) {
                      {{t('dashboard.KPI-min-period', {  period: t('calendar.' + this.period) })}}
                    } 
                    @else if(this.countExpense === 0) {} 
                    @else if(this.countExpense=== this.countExpensePrev) {} 
                    @else {
                      <span class="fw-bold">
                        {{
                        calculateAbs(this.countExpense, this.countExpensePrev)
                        }}
                      </span>
                      <span>(m/m)</span>
                      }
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <span>
            <h4>{{ t('dashboard.subheader-title') }}</h4>
          </span>
          <div class="d-flex">
            <span class="material-symbols-outlined m-1 cursor-pointer category-toggle-icon my-auto"
              (click)="toggleCategoriesView(this.categoriesView)">
              @if(categoriesView ==='grid') { table } @else { grid_view }
            </span>
          </div>
        </div>
        @if(categoriesView ==='grid') {
        <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4 g-3">
          <div class="col" *ngFor="let category of catsArray; index as i">
            <div class="card" [ngClass]="{'border-danger': category.content[this.period].budget == 0 && category.content[this.period].expense > 0}"
              title="{{category.content[this.period].budget == 0 && category.content[this.period].expense > 0 ? t('dashboard.grid-no-budget', { cat: category.content['name'], period: t('calendar.' + this.period) }) : ''}}"
              >
              <div class="d-flex justify-content-between py-sm-2 pt-2">
                <div class="d-flex">
                  <div class="ms-2">
                    <span class="category-name">{{
                      category.content['name']
                      }}</span>
                  </div>
                </div>
                <div class="category-total my-auto me-2" [ngClass]="{
                      'text-bad': category.content[this.period].expense > category.content[this.period].budget,
                      'text-ok':  category.content[this.period].expense / category.content[this.period].budget > 0.95,
                      'text-good': category.content[this.period].budget > category.content[this.period].expense,
                      }" title="{{t('dashboard.grid-balance', { cat: category.content['name'], period: t('calendar.' + this.period) })}}">
                  {{
                  category.content[this.period].budget -
                  category.content[this.period].expense
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </div>
              </div>
              <div class="d-flex justify-content-between m-2">
                <div class="d-flex" title="{{t('dashboard.grid-budget', { cat: category.content['name'], period: t('calendar.' + this.period) })}}">
                  <span class="material-symbols-outlined align-items-center me-2 cursor-pointer" routerLink="/budget"
                    title="{{t('menu.selection-budget')}}">savings</span>

                  {{
                  category.content[this.period].budget
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </div>
                <div class="d-flex" title="{{t('dashboard.grid-expense', { cat: category.content['name'], period: t('calendar.' + this.period) })}}">
                  <span class="material-symbols-outlined align-items-center me-2 cursor-pointer"
                    routerLink="/transactions" title="{{t('menu.selection-transactions')}}">receipt_long</span>
                  {{
                  category.content[this.period].expense
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </div>
              </div>

              <div class="progress mx-3 mb-3" role="progressbar" aria-label="Info example"
                attr.aria-valuenow="{{ category.content[this.period].expense }}" aria-valuemin="0"
                attr.aria-valuemax="{{ category.content[this.period].budget }}" style="height: 10px">
                <div class="progress-bar"
                  [style.width.%]="category.content[this.period].budget ==0 ? 0 :
100 -((category.content[this.period].budget - category.content[this.period].expense) / category.content[this.period].budget) *100" 
                  [ngClass]="{
                      'pb-nan': category.content[this.period].budget == 0 && category.content[this.period].expense == 0,
                      'pb-bad': category.content[this.period].expense > category.content[this.period].budget,
                      'pb-ok':  category.content[this.period].expense / category.content[this.period].budget > 0.95,
                      'pb-good': category.content[this.period].budget > category.content[this.period].expense}" 
                      
                      title="{{t('dashboard.grid-progress', { pct: 
                    ((category.content[this.period].expense /
                      category.content[this.period].budget)*100).toFixed(1),cat: category.content['name'], period: t('calendar.' + this.period) })}}"></div>
              </div>
            </div>
          </div>
        </div>

        } @else {
        <div class="card ps-1 pt-1 pe-1 pb-0">
          <table class="table mb-0 border-bottom-white">
            <thead>
              <tr>
                <th class="col category-table-header text-start">
                  {{ t('dashboard.list-col-category') }}
                </th>
                <th class="col category-table-header text-end">
                  {{ t('dashboard.list-col-budget') }}
                </th>
                <th class="col category-table-header text-end">
                  {{ t('dashboard.list-col-expense') }}
                </th>
                <th class="col category-table-header text-end">
                  {{ t('dashboard.list-col-diff-total') }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let category of catsArray; index as i">
                <td class="category-table-data text-start">
                  {{ category.content['name'] }}
                </td>
                <td class="category-table-data text-end">
                  {{
                  category.content[this.period].budget
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </td>
                <td class="category-table-data text-end">
                  {{
                  category.content[this.period].expense
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </td>
                <td class="category-table-data text-end" title='{{
                category.content[this.period].expense /
                category.content[this.period].budget | percent : "1.1-1"
                }}' [ngClass]="{
                      'text-bad': category.content[this.period].expense > category.content[this.period].budget,
                      'text-ok':  category.content[this.period].expense / category.content[this.period].budget > 0.95,
                      'text-good': category.content[this.period].expense < category.content[this.period].budget
                  }">
                  {{
                  category.content[this.period].budget -
                  category.content[this.period].expense
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th class="col category-table-header text-startd">
                  {{ t('dashboard.list-total') }}
                </th>
                <th class="col category-table-header text-end">
                  {{
                  this.totalBudget
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </th>
                <th class="col category-table-header text-end">
                  {{
                  this.totalExpense
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </th>
                <th class="col category-table-header text-end" 
                  [ngClass]="{
                      'text-bad': totalExpense > totalBudget,
                      'text-ok':  totalExpense / totalBudget > 0.95,
                      'text-good': totalExpense < totalBudget
                  }"
                  >
                  {{
                  this.totalBudget - this.totalExpense
                  | currency
                  : this.db.currentUserDataSig()?.currency
                  : "symbol-narrow"
                  }}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
        } }
        } @if (auth.currentUserIDSig()?.uid == null) {
        <div class="row">
          <div class="col">
            <span class="placeholder-glow">
              <span class="placeholder placeholder-lg col-4"></span>
            </span>
          </div>
          <div class="col text-end">
            <span class="placeholder-glow">
              <span class="placeholder placeholder-lg bg-secondary col-4"></span>
            </span>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col text-center">
            <div class="svl-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
</div>
<!-- MODALS -->

<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="infoKPIModal" tabindex="-1"
  aria-labelledby="infoKPIModalLabel" aria-hidden="true" *transloco="let t">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col text-end">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <span class="material-symbols-outlined modal-icon-grey align-content-center">
              info
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col text-center">
            <h5>{{ t('dashboard.indicators') }}</h5>
            <br />

            <div class="card shadow-sm">
              <div class="card-header bg-white">
                <b>{{ t('dashboard.stats-sum') }}</b>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="display-6 border-dashed border-danger">
                    {{
                    1234.56
                    | currency
                    : this.db.currentUserDataSig()?.currency
                    : "symbol-narrow"
                    }}
                  </span>
                </div>

                <div class="d-flex justify-content-between mt-2">
                  <span class="KPI-header d-none d-sm-block fst-italic border-dashed border-success">
                    <span>
                      {{ t('dashboard.KPI-comment-sum-of-expenses-more') }}
                    </span>

                    <span class="fw-bold text-blue">
                      {{
                      321.23
                      | currency
                      : this.db.currentUserDataSig()?.currency
                      : "symbol-narrow"
                      }}</span>
                    <span> (m/m)</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-content-center mt-4">
              <span class="border-dashed border-danger p-2">
                <b>{{ t('dashboard.KPI-help-main-indicator') }}</b>
              </span>
              <p>
                {{ t('dashboard.KPI-help-main-indicator-description') }}
                <b>{{ t('calendar.202505') }}</b>
              </p>
            </div>
            <div class="d-flex justify-content-between align-content-center mt-4">
              <span class="border-dashed border-success p-2 my-auto">
                <b>{{ t('dashboard.KPI-help-secondary-indicator') }}</b>
              </span>
              <p>
                {{ t('dashboard.KPI-help-secondary-indicator-description-1') }}<b>{{ t('calendar.202505') }}</b> {{ t('dashboard.KPI-help-secondary-indicator-description-2') }}
                <b>{{ t('calendar.202504') }}</b>. <br />{{ t('dashboard.KPI-help-secondary-indicator-description-3') }}
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer px-0">
          <div class="container-fluid">
            <div class="row">
                <div class="col-8 d-grid">

                </div>
                <div class="col-4 d-grid">
                    <button class="btn btn-sm btn-outline-secondary rounded-pill" data-bs-dismiss="modal" type="button"
                        title="{{t('general.button-close')}}">{{t('general.button-close')}}</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>